import { Plus } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { parseError } from '@/lib/errors'
import { useCreateSequenceTemplate } from '@/models/sequenceTemplate'

interface NewSequenceTemplateButtonProps {
  isGlobal: boolean
  onCreated: (id: string) => void
}

export function NewSequenceTemplateButton({ isGlobal, onCreated }: NewSequenceTemplateButtonProps) {
  const createMutation = useCreateSequenceTemplate()

  function handleCreate() {
    createMutation.mutate(
      { name: 'Untitled', isGlobal, steps: [] },
      {
        onSuccess: (created) => onCreated(created.id),
        onError: (err) => toast.error(parseError(err)),
      }
    )
  }

  return (
    <Button
      onClick={handleCreate}
      loading={createMutation.isPending ? 'Creating…' : undefined}
      className="text-md w-full justify-start"
    >
      <Plus />
      New template
    </Button>
  )
}
